import { createSelector } from "reselect";
import { initialState } from "./reducer";

/**
 * Direct selector to the agenda state domain
 */

const selectAgendaDomain = state => state.agenda || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectAgendaDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectAgendaDomain,
    substate => substate.error,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectAgendaDomain,
    substate => substate.firstRender,
  );

const makeSelectItemsList = () =>
  createSelector(
    selectAgendaDomain,
    substate => substate.itemsList,
  );
const makeSelectAppointments = () =>
  createSelector(
    selectAgendaDomain,
    substate => substate.appointments,
  );

/**
 * Default selector used by Courses
 */

const makeSelectAgenda = () =>
  createSelector(
    selectAgendaDomain,
    substate => substate,
  );

export default makeSelectAgenda;
export {
  selectAgendaDomain,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemsList,
  makeSelectAppointments,
};
